// extracted by mini-css-extract-plugin
export default {"meatball":"case-drafts-table-meatball__meatball--_MnaX"};